import { Component, OnInit } from '@angular/core';
import { AdminService } from 'src/app/services/Admin/admin.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-student-login',
  templateUrl: './student-login.component.html',
  styleUrls: ['./student-login.component.css']
})
export class StudentLoginComponent implements OnInit {


  IDPasswordList = [];
  StudentList = [];
  Submitted = false;
  Count1 = 0;
  PersonList = [];
  ClassList = [];
  SectionList = [];
  Student = [];
  StudentResetList = [];

  constructor(private adminservice: AdminService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  StudentLoginModel = {
    CurrentIndex: 0,
    PageSize: 0,
    StudentID: 0,
    SectionID: 0,
    UserLoginID: 0,
    ClassID: 0,

  }

  ValidityState() {
    return this.StudentLoginModel.ClassID == 0;
  }

  SendStudentLoginID() {
    this.IDPasswordList = [];
    for (var i = 0; i < this.StudentList.length; i++) {
      if (this.StudentList[i].IsSelectAction == true && this.StudentList[i].UserID != null) {
        var item = {
          UserID: this.StudentList[i].UserID,
          Pasword: this.StudentList[i].Password,
          Keys: this.StudentList[i].Keys,
          Mobile: this.StudentList[i].Mobile,
          Name: this.StudentList[i].Name,
        }
        this.IDPasswordList.push(item);
      }

    }
    this.spinnerService.show();
    this.adminservice.SendStudentLoginID(JSON.stringify(this.IDPasswordList)).subscribe((data: any) => {
      this.spinnerService.hide();
      if (data.webResponse.Status) {
        this.ClearSelection();

      }
      this.globalHelper.CheckActionStatus(data);
    });


  }

  GetStudentLoginID() {
    this.Submitted = true;
    if (!this.ValidityState()) {
      this.spinnerService.show();

      this.adminservice.GetStudentLoginID(JSON.stringify(this.StudentLoginModel)).subscribe((data: any) => {
        this.StudentList = data.StudentList;
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(data);
      });
    }
  };

  ChangePersonType() {
    this.StudentList = [];
    this.SelectModel.IsSelect = false;

    for (var i = 0; i < this.StudentList.length; i++) {
      this.StudentList[i].Active = false;

    }
  }

  SelectModel = {
    IsSelect: false,
    IsAction: false,
  }

  SelectAll() {
    if (this.SelectModel.IsSelect) {
      for (var i = 0; i < this.StudentList.length; i++) {
        this.StudentList[i].Active = true;
      }
    }
    if (this.SelectModel.IsSelect == false) {
      for (var i = 0; i < this.StudentList.length; i++) {
        this.StudentList[i].Active = false;
      }
    }
  }
  ChangeSelect(item) {
    this.Count1 = 0;

    for (var i = 0; i < this.StudentList.length; i++) {
      if (this.StudentList[i].Active) {
        this.Count1 = this.Count1 + 1

      }
    }


    if (this.Count1 == this.StudentList.length) {
      this.SelectModel.IsSelect = true;

    }
    else {
      this.SelectModel.IsSelect = false;
    }

  }


  SaveStudentLoginID() {
    this.PersonList=[];
    this.Submitted = true;
    if (!this.ValidityState()) {
      this.spinnerService.show();
      for (var i = 0; i < this.StudentList.length; i++) {
        if (this.StudentList[i].Active == true && this.StudentList[i].UserID == null) {
          var Password = this.StudentList[i].StudentNo;
          var item = {
              StudentNo: this.StudentList[i].StudentNo,
              StudentID: this.StudentList[i].StudentID,
              Password: Password
          }
          this.PersonList.push(item);
      }

      }


      this.adminservice.SaveStudentLoginID(JSON.stringify(this.StudentLoginModel), JSON.stringify(this.PersonList)).subscribe((data: any) => {
        if (data.webResponse.Status) {
          this.PersonList.splice(0);
          this.ClearSelection();
          this.GetStudentLoginID();
        }
        this.globalHelper.CheckActionStatus(data);
      });
    }

  }



  GetSection() {
    this.spinnerService.show();
    this.StudentList = [];
    this.StudentLoginModel.SectionID = 0;
    this.StudentLoginModel.StudentID = 0;
    var itemBo = {
      'ItemId': this.StudentLoginModel.ClassID
    };
    this.lookupservice.GetLookupsList('SectionName', JSON.stringify(itemBo)).subscribe((data: any) => {
      this.SectionList = data.LookupItems;
      this.spinnerService.hide();
    });

  };

  GetStudent() {
    this.StudentList = [];
    this.spinnerService.show();
    var itemBo = {
      'ItemId': this.StudentLoginModel.ClassID,
      'ItemId2': this.StudentLoginModel.SectionID
    };
    this.lookupservice.GetLookupsList('Student', JSON.stringify(itemBo)).subscribe((data: any) => {
      this.Student = data.LookupItems;
      this.spinnerService.hide();
    });
  };

  GetClass() {
    this.lookupservice.GetLookupsList('Class', '').subscribe((data: any) => {
      this.ClassList = data.LookupItems;
    });
  };

  // Password Reset

  ClearSelection() {
    this.SelectModel.IsSelect = false;
    this.SelectModel.IsAction = false;
  }

  SelectAllAction() {
    if (this.SelectModel.IsAction) {
      for (var i = 0; i < this.StudentList.length; i++) {
        this.StudentList[i].IsSelectAction = true;
      }
    }
    if (this.SelectModel.IsAction == false) {
      for (var i = 0; i < this.StudentList.length; i++) {
        this.StudentList[i].IsSelectAction = false;

      }
    }

  }

  ChangeActionSelect = function (item) {
    this.Count = 0;
    for (var i = 0; i < this.StudentList.length; i++) {
      if (this.StudentList[i].IsSelectAction) {
        this.Count = this.Count + 1

      }
    }


    if (this.Count == this.StudentList.length) {
      this.SelectModel.IsAction = true;
    }

    else {
      this.SelectModel.IsAction = false;
    }

  }
  ResetStudentLoginID() {
    this.StudentResetList = [];
    this.spinnerService.show();
    for (var i = 0; i < this.StudentList.length; i++) {
      if (this.StudentList[i].IsSelectAction == true && this.StudentList[i].UserID != null) {
        var item = {
          UserID: this.StudentList[i].UserID,
          Password: this.StudentList[i].StudentNo,
        }
        this.StudentResetList.push(item);
      }

    }
    this.adminservice.ResetStudentLoginID(JSON.stringify(this.StudentResetList)).subscribe((data: any) => {
      this.spinnerService.hide();
      if (data.webResponse.Status) {
        this.ClearSelection();
        this.GetStudentLoginID();
      }
      this.globalHelper.CheckActionStatus(data);
    });


  }

  // Mark Active/InActive

  MarkActiveStudentLoginID() {
    this.StudentResetList = [];
    this.spinnerService.show();
    for (var i = 0; i < this.StudentList.length; i++) {
      if (this.StudentList[i].IsSelectAction == true && this.StudentList[i].UserID != null) {
        var item = {
          UserID: this.StudentList[i].UserID,
          IsActive: this.StudentList[i].IsActive == false ? true : false
        }
        this.StudentResetList.push(item);
      }

    }
    this.adminservice.MarkActiveStudentLoginID(JSON.stringify(this.StudentResetList)).subscribe((data: any) => {
      this.spinnerService.hide();
      if (data.webResponse.Status) {
        this.ClearSelection();
        this.GetStudentLoginID();
      }
      this.globalHelper.CheckActionStatus(data);
    });


  }



  ngOnInit() {
    this.GetClass();   
  }

}

